var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { DeviceAndOrgReq, DeviceAndOrgStage, DeviceAndOrgUpdateStage, DeviceRegReq, NewOrgReq } from "@/share/DeviceAndOrg";
import { RegisterRequestType, RegisterStage } from "@/share/models";
import { PinVerifyReq } from "@/share/PinVerifyReq";
import { action, makeObservable, observable } from "mobx";
import { ProgressBarState } from "../UIComponents/ProgressBar";
export class NewOrgFormState {
    constructor() {
        this.name = "";
        this.password = "";
        this.secret = "";
        this.orgname = "";
        this.orgerror = "";
        this.nameerror = "";
        this.passcodeerror = "";
        this.secreterror = "";
        this.registerViaDevice = true;
        makeObservable(this);
    }
    setName(name) {
        this.name = name;
    }
    setPassword(password) {
        this.password = password;
    }
    setSecret(secret) {
        this.secret = secret;
    }
    setOrgname(oname) {
        this.orgname = oname;
    }
    setNameError(msg) {
        this.nameerror = msg;
    }
    setSecretError(msg) {
        this.secreterror = msg;
    }
    setPasscodeError(msg) {
        this.passcodeerror = msg;
    }
    setOrgError(msg) {
        this.orgerror = msg;
    }
    reset() {
        this.setName("");
        this.setSecret("");
        this.setPassword("");
        this.setOrgname("");
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], NewOrgFormState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewOrgFormState.prototype, "password", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewOrgFormState.prototype, "secret", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewOrgFormState.prototype, "orgname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewOrgFormState.prototype, "orgerror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewOrgFormState.prototype, "nameerror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewOrgFormState.prototype, "passcodeerror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewOrgFormState.prototype, "secreterror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewOrgFormState.prototype, "registerViaDevice", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewOrgFormState.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewOrgFormState.prototype, "setPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewOrgFormState.prototype, "setSecret", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewOrgFormState.prototype, "setOrgname", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewOrgFormState.prototype, "setNameError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewOrgFormState.prototype, "setSecretError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewOrgFormState.prototype, "setPasscodeError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewOrgFormState.prototype, "setOrgError", null);
export class RegisterStore {
    constructor() {
        this.registerStage = RegisterStage.Register;
        this.email = "";
        this.orgcode = "";
        this.passcode = "";
        this.showRegisterDevicePassword = false;
        this.progressstate = new ProgressBarState();
        this.newOrgState = new NewOrgFormState();
        this.masterPassword = "";
        this.failedsecuringdevice = false;
        this.selectedregisterorg = "";
        this.acceptinginvite = false;
        this.acceptedorgname = "";
        this.verifiedReg = { tenantid: "", invitesorg: [], sessionid: "" };
        makeObservable(this);
        APPEvent.addSubscriberForRegisterStage(stage => this.handleRegisterUpdate(stage));
        APPEvent.addSubscriberForDeviceOrgUpdate(update => this.handleDevceOrgUpdate(update));
        APPEvent.addSubscriberForAcceptRes((res) => {
            if (this.acceptinginvite) {
                this.newOrgState.reset();
                this.identitytoken = res;
                this.setRegisterStage(RegisterStage.RegsiterUserToOrg);
                this.setAcceptingInvite(false);
            }
        });
        APPEvent.addSubscriberForReset(() => {
            this.setEmail("");
            this.setOrgCode("");
            this.setPasscode("");
            this.setFailedSecuringDevice(false);
            this.setAcceptingInvite(false);
            this.masterPassword = "";
            this.acceptedorgname = "";
            this.identitytoken = undefined;
            this.verifiedReg = { tenantid: "", invitesorg: [], sessionid: "" };
        });
    }
    handleDevceOrgUpdate(update) {
        if (this.registerStage === RegisterStage.Securing) {
            if (update.masterpassword) {
                this.masterPassword = update.masterpassword;
            }
            switch (update.updateStage) {
                case DeviceAndOrgUpdateStage.RegisteredOrg:
                    this.setProgress(30);
                    this.setProgressMessage("Created New Organisation " + this.newOrgState.orgname);
                    this.setProgressColor("green");
                    break;
                case DeviceAndOrgUpdateStage.RegisteredUser:
                    this.setProgress(60);
                    this.setProgressMessage("Added to " + (this.acceptedorgname !== '' ? this.acceptedorgname : this.newOrgState.orgname));
                    this.setProgressColor("green");
                    break;
                case DeviceAndOrgUpdateStage.RegsiteredDevice:
                    this.setProgressMessage("Secured this device. Doing last few checks");
                    this.setProgress(90);
                    this.setProgressColor("green");
                    break;
                case DeviceAndOrgUpdateStage.AddingUserError:
                    this.setProgress(100);
                    this.setProgressMessage("Sorry, failed to register the user. Please try again or contact support.");
                    this.setProgressColor("red");
                    this.setRegisterStage(RegisterStage.ProgressError);
                    break;
                case DeviceAndOrgUpdateStage.RegisterUserDeviceFail:
                    this.setProgress(100);
                    this.setProgressMessage("Sorry, failed to securely register this device. Please try again to register this device");
                    this.setProgressColor("red");
                    this.setRegisterStage(RegisterStage.ProgressError);
                    break;
                case DeviceAndOrgUpdateStage.RegCreationError:
                    this.setProgress(100);
                    this.setProgressMessage("Sorry, failed to create the new organisation. Please try again or contact support.");
                    this.setProgressColor("red");
                    this.setRegisterStage(RegisterStage.ProgressError);
                    break;
                case DeviceAndOrgUpdateStage.DeviceRegError:
                    this.setFailedSecuringDevice(true);
                    this.setRegisterStage(RegisterStage.ProgressError);
                    this.setProgress(100);
                    this.setProgressMessage("Sorry, failed securing this device. Please try again.");
                    this.setProgressColor("red");
                    break;
                case DeviceAndOrgUpdateStage.ShowOrgCreated:
                    this.setProgress(100);
                    this.setRegisterStage(RegisterStage.ShowOrgCreated);
                    break;
                case DeviceAndOrgUpdateStage.ShowOrgCreatedAndDeviceFailed:
                    this.setProgress(100);
                    this.setRegisterStage(RegisterStage.ShowOrgCreated);
                    this.setProgressMessage("Sorry, failed securing this device. Please try again.");
                    this.setProgressColor("red");
                    break;
            }
        }
    }
    registerUserToOrg() {
        if (this.identitytoken === undefined) {
            return;
        }
        this.setProgressMessage("Adding User");
        this.setRegisterStage(RegisterStage.Securing);
        const name = this.newOrgState.name;
        const password = this.newOrgState.password;
        const secret = this.newOrgState.secret;
        const orgid = this.selectedregisterorg;
        const tokn = this.identitytoken;
        const req = {
            name: name,
            pin: password,
            secret: secret,
            orgid: orgid,
            token: tokn
        };
        Apphandler.sendMessage("registerusertoorg", req);
    }
    handleRegisterUpdate(update) {
        if (update.errormessgae) {
            APPEvent.publishApperror(update.errormessgae);
        }
        if (update.stage !== RegisterStage.Register) {
            if (update.invitesOrg) {
                this.verifiedReg.invitesorg = update.invitesOrg;
                if (update.invitesOrg.length === 1) {
                    this.selectedRegsiterOrg(update.invitesOrg[0].id);
                }
            }
            if (update.tenantid) {
                this.verifiedReg.tenantid = update.tenantid;
            }
            if (update.sessionid) {
                this.verifiedReg.sessionid = update.sessionid;
            }
            if (update.identitytoken !== undefined) {
                this.verifiedReg.token = update.identitytoken;
            }
        }
        else {
            this.verifiedReg = { tenantid: "", invitesorg: [], sessionid: "" };
        }
        this.setRegisterStage(update.stage);
    }
    acceptInvite() {
        if (!this.selectedregisterorg.trim()) {
            return;
        }
        this.setRegisterStage(RegisterStage.Processing);
        this.setAcceptingInvite(true);
        const req = {
            orgid: this.selectedregisterorg,
            session: this.verifiedReg.sessionid
        };
        Apphandler.sendMessage("acceptorgreq", req);
    }
    setAcceptingInvite(accept) {
        this.acceptinginvite = accept;
    }
    selectedRegsiterOrg(org) {
        this.selectedregisterorg = org;
    }
    setFailedSecuringDevice(failed) {
        this.failedsecuringdevice = failed;
    }
    toggleShowRegisterDevicePassword() {
        this.showRegisterDevicePassword = !this.showRegisterDevicePassword;
    }
    setProgress(pr) {
        this.progressstate.setProgress(pr);
    }
    setProgressColor(color) {
        this.progressstate.setColor(color);
    }
    setProgressMessage(msg) {
        this.progressstate.setProgressMessage(msg);
    }
    setEmail(email) {
        this.email = email;
        if (email) {
            this.setOrgCode("");
        }
        this.setPasscode("");
    }
    setOrgCode(code) {
        this.orgcode = code;
        if (code) {
            this.setEmail("");
        }
        this.setPasscode("");
    }
    setPasscode(code) {
        this.passcode = code;
    }
    setRegisterStage(stage) {
        this.registerStage = stage;
        if (stage === RegisterStage.Securing) {
            this.progressstate.setProgress(0);
            this.progressstate.setProgressMessage("");
        }
    }
    reset() {
        this.setEmail("");
        this.setOrgCode("");
        this.setPasscode("");
        this.newOrgState.reset();
        this.setRegisterStage(RegisterStage.Register);
    }
    register() {
        const rreq = { email: "", orgid: "", type: RegisterRequestType.Email, pin: "" };
        // now we will start maing 
        if (this.email) {
            rreq.email = this.email;
            rreq.type = RegisterRequestType.Email;
        }
        else if (this.orgcode) {
            rreq.orgid = this.orgcode;
            rreq.type = RegisterRequestType.OrgCode;
        }
        // now lets change the stage and make a request to backgend process!
        this.setRegisterStage(RegisterStage.Processing);
        Apphandler.sendMessage('registerrequest', rreq);
    }
    verifyPin() {
        if (!this.email) {
            this.setRegisterStage(RegisterStage.Register);
            return;
        }
        if (!this.passcode) {
            return;
        }
        // otherwise we will just send the request to the backend process and will verify pin
        const req = new PinVerifyReq();
        req.email = this.email;
        req.pin = this.passcode;
        req.tenant = this.verifiedReg.tenantid;
        this.setRegisterStage(RegisterStage.Processing);
        Apphandler.sendMessage("pinverify", req);
    }
    newOrgRegister() {
        this.setRegisterStage(RegisterStage.Securing);
        this.setProgressMessage("Creating New Organisation " + this.newOrgState.orgname);
        const dorg = new NewOrgReq(this.email, this.newOrgState.orgname, this.verifiedReg.sessionid, this.newOrgState.password, this.newOrgState.name, this.newOrgState.secret);
        const req = new DeviceAndOrgReq(dorg, DeviceAndOrgStage.NewOrgReq);
        Apphandler.sendMessage("organddevicereq", req);
    }
    resendCode() {
        Apphandler.sendMessage("resendcode", this.email);
    }
    registerThisDevice() {
        this.setRegisterStage(RegisterStage.Securing);
        this.setProgressMessage("Securing this device");
        this.setProgress(0);
        this.setProgressColor("green");
        if (this.verifiedReg.token !== undefined) {
            const sor = new DeviceRegReq(this.newOrgState.password, this.verifiedReg.tenantid, this.verifiedReg.token);
            const req = new DeviceAndOrgReq(sor, DeviceAndOrgStage.RegisterDevice);
            Apphandler.sendMessage("organddevicereq", req);
        }
        else {
            this.setProgressMessage("Sorry, failed securing this device.");
            this.setProgress(100);
            this.setProgressColor("red");
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], RegisterStore.prototype, "registerStage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterStore.prototype, "email", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterStore.prototype, "orgcode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterStore.prototype, "passcode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterStore.prototype, "showRegisterDevicePassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterStore.prototype, "failedsecuringdevice", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterStore.prototype, "selectedregisterorg", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterStore.prototype, "acceptinginvite", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RegisterStore.prototype, "setAcceptingInvite", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RegisterStore.prototype, "selectedRegsiterOrg", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RegisterStore.prototype, "setFailedSecuringDevice", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RegisterStore.prototype, "toggleShowRegisterDevicePassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RegisterStore.prototype, "setEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RegisterStore.prototype, "setOrgCode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RegisterStore.prototype, "setPasscode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RegisterStore.prototype, "setRegisterStage", null);
